import { CustomMessageEvent } from './websocket.worker';
import {
    WebsocketWorkerMessageEvent,
    WebsocketWorkerType
} from './WebsocketWorker.types';
type ListenerFunc = (e: MessageEvent) => void;

type EventSubscriber = {
    name: string;
    listener: ListenerFunc;
};

class EventStore {
    websocketWorker: WebsocketWorkerType;
    events: MessageEvent[];
    subscribers: Map<string, EventSubscriber>;
    bookmarks: Map<string, number>;

    constructor(websocketWorker: WebsocketWorkerType) {
        this.websocketWorker = websocketWorker;
        this.events = [];
        this.subscribers = new Map<string, EventSubscriber>();
        this.bookmarks = new Map<string, number>();
        this.eventReceived = this.eventReceived.bind(this);
        this.processMessages = this.processMessages.bind(this);
        this.addEventListener = this.addEventListener.bind(this);
        this.removeEventListener = this.removeEventListener.bind(this);
        this.websocketWorker.addEventListener(
            'message',
            (
                event:
                    | MessageEvent<unknown>
                    | CustomMessageEvent
                    | WebsocketWorkerMessageEvent
            ) => this.eventReceived(event as WebsocketWorkerMessageEvent)
        );
    }

    eventReceived(event: WebsocketWorkerMessageEvent) {
        try {
            this.events = this.events.concat([event]);
            this.processMessages();
        } catch (error) {
            console.error('Error handling received events: ', error);
        }
    }

    processMessages(): void {
        const messages = this.events.slice();
        if (!messages) {
            return;
        }

        this.subscribers.forEach((v) => {
            const index = this.bookmarks.get(v.name) ?? 0;
            messages.slice(index).forEach((msg) => v.listener(msg));
            this.bookmarks.set(v.name, messages.length);
        });
    }

    addEventListener(name: string, listener: ListenerFunc): void {
        if (!this.bookmarks.get(name)) {
            this.bookmarks.set(name, 0);
        }
        this.subscribers.set(name, {
            name,
            listener
        });
        this.processMessages();
    }

    removeEventListener(name: string): void {
        this.subscribers.delete(name);
        if (this.subscribers.size === 0) {
            this.events = [];
            this.bookmarks.clear();
        }
    }
}

export default EventStore;
